import { useMemo } from 'react';
import { type AmountUnit } from '../../../../../../api/types';
import { type VariantOption } from '../../../shared/useSelectedVariants';
import { type Columns } from '../EditableTable';
import { type LeasePurchaseTableRecord } from './shared';

const useColumns = (
    title: string,
    terms: number[],
    variants: VariantOption[],
    disabled: boolean,
    onUpdate: (record: LeasePurchaseTableRecord) => void,
    valueUnit: AmountUnit
) =>
    useMemo<Columns<LeasePurchaseTableRecord>>(() => {
        const variantFilters = variants.map(variant => ({
            text: variant.name,
            value: variant.id,
        }));

        const results: Columns<LeasePurchaseTableRecord> = [
            {
                title,
                dataIndex: 'variantNameMileage',
                fixed: true,
                filters: variantFilters,
                onFilter: (value: string, record) => record.variantSuiteId === value,
                className: 'variant-column',
            },
        ];

        const termColumns = terms.map(term => ({
            title: `${term}`,
            dataIndex: `term${term}`,
            onCell: (record: LeasePurchaseTableRecord) => ({
                record,
                dataIndex: `term${term}`,
                isEditable: !disabled,
                onUpdate,
                valueUnit,
            }),
            className: 'terms-column',
        }));

        return [...results, ...termColumns];
    }, [variants, title, terms, disabled, onUpdate, valueUnit]);

export default useColumns;
